;(function() {
  'use strict'

  Controller.$inject = ["surveyReport", "subscriberService", "userService"];
  angular.module('app.core').component('exportResponsesDialog', {
    controller: Controller,
    templateUrl: 'export-responses-dialog.html',
    bindings: {
      survey: '<',
      channels: '<',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller(surveyReport, subscriberService, userService) {
    var ctrl = this
    var ALL_CHANNELS_VALUE = 'ALL_CHANNELS'

    ctrl.$onInit = onInit
    ctrl.exportResponses = exportResponses
    ctrl.canExport = canExport
    ctrl.onChannelsChange = onChannelsChange
    ctrl.formatChannelsLabel = formatChannelsLabel

    function onInit() {
      ctrl.subscriber = subscriberService.getSubscriber()
      ctrl.isSSR = userService.isSSR()
      ctrl.exportFormatOptions = [
        {
          label: 'CSV',
          value: 'qcsv',
        },
        {
          label: 'XLSX',
          value: 'qxlsx',
        },
        {
          label: 'SPSS Compatible xlsx',
          value: 'qspss',
        },
      ]
      ctrl.responseTypeOptions = [
        {
          label: 'All',
          value: null,
        },
        {
          label: 'Completes',
          value: 'COMPLETE',
        },
        {
          label: 'Exits',
          value: 'EXIT',
        },
        {
          label: 'Overquota',
          value: 'OVERQUOTA',
        },
        {
          label: 'Quality Exits',
          value: 'QUALITYEXIT',
        },
      ]
      ctrl.questionsModeOptions = [
        {
          label: 'All questions (incl. hidden)',
          value: 'ALL_INCLUDING_HIDDEN',
        },
        {
          label: 'Visible questions',
          value: 'EDITOR_VISIBLE',
        },
      ]
      ctrl.channelOptions = buildChannelOptions()
      // pre select export format and response type
      ctrl.exportFormat = 'qcsv'
      ctrl.responseType = 'COMPLETE'
      ctrl.questionsMode = 'ALL_INCLUDING_HIDDEN'
      // pre-tick "All" plus every channel
      ctrl.selectedChannels = _.map(ctrl.channelOptions, 'value')
    }

    function buildChannelOptions() {
      var options = [
        { value: ALL_CHANNELS_VALUE, label: 'All', promoted: true },
      ]
      _.each(ctrl.channels || [], function(channel) {
        options.push({ value: channel.id, label: channel.name })
      })
      return options
    }

    function canExport() {
      if (hasAllChannelsSelected()) return true
      return ctrl.selectedChannels.length > 0
    }

    function hasAllChannelsSelected() {
      return ctrl.selectedChannels.indexOf(ALL_CHANNELS_VALUE) !== -1
    }

    function onChannelsChange(newValues) {
      var prev = ctrl.selectedChannels || []
      var addedItems = _.difference(newValues, prev)
      var removedItems = _.difference(prev, newValues)
      var changes = addedItems.length + removedItems.length

      if (changes === 0) return

      if (changes > 1) {
        // bulk action (Select All / Select None) — accept as-is
        ctrl.selectedChannels = newValues.slice()
        return
      }

      var added = addedItems[0]
      var removed = removedItems[0]
      if (added === ALL_CHANNELS_VALUE) {
        // user ticked "All" → ensure every real channel is also ticked
        ctrl.selectedChannels = _.map(ctrl.channelOptions, 'value')
      } else if (removed === ALL_CHANNELS_VALUE) {
        // user unticked "All" only → leave channel ticks intact
        ctrl.selectedChannels = newValues.slice()
      } else {
        // user toggled a real channel → auto-untick "All" if it was on
        ctrl.selectedChannels = newValues.filter(function(v) {
          return v !== ALL_CHANNELS_VALUE
        })
      }
    }

    function formatChannelsLabel($options) {
      var hasAll = _.some($options, { value: ALL_CHANNELS_VALUE })
      if (hasAll) return 'All channels'
      var count = $options.length
      if (count === 0) return 'No channels selected'
      if (count === 1) return $options[0].label
      return count + ' channels selected'
    }

    function exportResponses() {
      var allowHidden = ctrl.questionsMode === 'ALL_INCLUDING_HIDDEN'
      var channelIds = []
      if (!hasAllChannelsSelected()) {
        channelIds = ctrl.selectedChannels.slice()
      }

      var options = {
        surveyId: ctrl.survey.id,
        responseType: ctrl.responseType,
        allowHidden: allowHidden,
        channelIds: channelIds,
      }
      if (ctrl.exportFormat === 'qxlsx') {
        options.exportFormat = 'xlsx'
      }
      if (ctrl.exportFormat === 'qspss') {
        options.exportFormat = 'spss'
      }
      // IMPORTANT: SPSS doesn't support durations so we should always set it to false
      options.withDuration =
        options.exportFormat !== 'spss' &&
        ctrl.isSSR &&
        ctrl.subscriber.data.withDurationExport
      surveyReport.createExport(options)
      ctrl.onClose()
    }
  }
})()
